import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mortgage } from '../../dialer/model/model.mortgage';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {

  @Input() data:any[];
  @Output() rowclick: EventEmitter<Mortgage> = new EventEmitter();

  constructor() {
      
  }

  ngOnInit() {
  }

  onLeadClick(data:any)
  {
    //console.log("this leadliist component"+JSON.stringify(data));
    this.rowclick.emit(data);
  }

}
